import React from 'react';

export const NoData: React.FC = () => {
  return (
    <div className="pl-5 pt-[5px]">
      <p>None Found</p>
    </div>
  );
};
